import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LazyImage,
  SpanStyled,
} from "../styled/Elements";
import { useState } from "react";
import { HeaderContainer } from "./styled";
import {
  AvatarPlaceholder,
  Bell,
  Logo,
  Logout,
  ProfileImg,
  SearchIcon,
} from "../styled/AllImages";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LangChangeButton from "../../languages/LangChangeButton";
import CustomDropdown from "../common/dropdowns/CustomDropdown";
import { profileDropdownList } from "../../helpers/webConstants";
import ValidatedInput from "../common/inputFields/ValidatedInput";
import FloatingInput from "../common/inputFields/FloatingInput";
import { Dropdown } from "react-bootstrap";
import { NotificationsList } from "./NotificationsList";
import { NotificationsListArray } from "../../helpers/dummyConstants";
import AuthApi from "../../services/api/authApi";
import { toast } from "react-toastify";
import LogoutModal from "../auth/Modal/LogoutModal";
import { AuthContext } from "../../context/authContext";
import { useUser } from "../../context/userContext";

import { resolveMediaUrl } from "../../utils/mediaUrl";

const ProfileDropdownTitle = () => {
  const { user } = useUser();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  return (
    <>
      <SpanStyled className="active-dot bg-transparent position-relative border-0 p-0">
        <LazyImage
          width="28px"
          height="28px"
          src={
            user?.profile
              ? resolveMediaUrl(user?.profile)
              : AvatarPlaceholder
          }
          className="rounded-circle"
        />
      </SpanStyled>
      <SpanStyled size="14px" className="mx-2 d-none d-sm-inline-block">
        {user?.name}
      </SpanStyled>
    </>
  );
};
const notifyDropdown = () => {
  return (
    <>
      <Bell className="bellNotify" />
    </>
  );
};
const MainHeader = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { logout, isAuthenticated } = useContext(AuthContext);

  const location = useLocation();
  const navigate = useNavigate();
  const [isSticky, setIsSticky] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showLogout, setShowLogout] = useState(false);

  const handleLogout = async () => {
    try {
      setIsLoading(true);
      const response = await AuthApi.logout();
      if (response.code === 200) {
        toast.success(t("logout_successfully"));
        logout();
        setShowLogout(false);
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box>
      <HeaderContainer>
        <Box
          className={`header-container headerBg ${isSticky ? "sticky" : ""}`}
        >
          <Box className="nav-bar">
            <Box className="logo" onClick={() => isAuthenticated ? navigate("/my-profile") : navigate("/")}>
              <Logo />
            </Box>
            <Box className="d-flex align-items-center headerActions">
              {![
                "/registration",
                "/under-review",
                "/profile-rejected",
              ].includes(location.pathname) && (
                <ButtonStyled
                  label={t("visit_home")}
                  bg="var(--white)"
                  border="var(--themeColorSecondary)"
                  radius="10px"
                  color="var(--themeColorSecondary)"
                  className="px-2 px-sm-3"
                  onClick={() => window.open("/", "_blank")}
                />
              )}
              <LangChangeButton
                bg="var(--bg)"
                border="1px solid var(--border)"
                color="var(--darkGrey)"
                iconColor="var(--darkGrey)"
              />
              {["/registration", "/under-review", "/profile-rejected"].includes(
                location.pathname
              ) ? (
                <ButtonStyled
                  label={t("Logout")}
                  color="var(--white)"
                  bg="var(--themeColorSecondary)"
                  clName={"signup-btn"}
                  className={""}
                  size="16px"
                  padding="11px 20px"
                  onClick={() => setShowLogout(true)}
                  icon={Logout}
                />
              ) : (
                <CustomDropdown
                  bg="var(--bg)"
                  color="var(--text)"
                  className=""
                  paddingY={5}
                  paddingX={16}
                  itemsList={profileDropdownList}
                  title={ProfileDropdownTitle()}
                  handleLogout={() => setShowLogout(true)}
                />
              )}
            </Box>
          </Box>
        </Box>
        <LogoutModal
          show={showLogout}
          onHide={() => setShowLogout(false)}
          handleLogout={handleLogout}
          isLoading={isLoading}
        />
      </HeaderContainer>
    </Box>
  );
};

export default MainHeader;
